import React from "react";
import "./Formatter.scss";
const Formatter = ({ header, children, color }) => {
  return (
    <div className="formatter" id={header}>
      <div
        style={{ borderBottom: `1px solid ${color} `, paddingBottom: 5 }}
        className="ms-2"
      >
        <div className="formatterHeader" style={{ backgroundColor: color }}>
          {header}
        </div>
      </div>

      {/* <hr style={{ color: color, backgroundColor: color }} /> */}
      {children}
    </div>
  );
};
export default Formatter;
